import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import map from 'lodash/map';
import find from 'lodash/find';
import transform from 'lodash/transform';
import isEmpty from 'lodash/isEmpty';
import { LoggerTypes } from './constants';
import { dateKind } from '../../../constants';
import { apiCallStatus } from 'helpers/constants';

const getShowUtcDates = ({ eventLog }) => {
	return eventLog.dateKind === dateKind.UTC;
};

const getEventLoggersData = ({ eventDetailsCMD }) => {
	const shownLoggerTypes = [LoggerTypes.DataLogger, LoggerTypes.FactoryLogger, LoggerTypes.TransientLogger];

	return eventDetailsCMD?.loggers?.data &&
		!isEmpty(eventDetailsCMD.loggers.data) ?
		eventDetailsCMD.loggers.data.filter(l => shownLoggerTypes.includes(LoggerTypes[l?.type])) : [];
};

const geSelectedLoggerSignalsData = ({ eventDetailsCMD }) => {
	return eventDetailsCMD.selectedLoggerSignals?.data;
};

const getEventLoggers = createSelector([
	getEventLoggersData,
	geSelectedLoggerSignalsData,
], (
	loggersData,
	selectedLoggerSignalsData,
) => {
	return map(loggersData, (logger) => {
		return {
			...logger,
			label: logger.filename,
			signals: transform(logger.signals, (acc, signal) => {
				if (!find(selectedLoggerSignalsData, { loggerID: logger.id, signalID: signal.id })) {
					acc.push({
						label: signal,
						value: signal,
						id: signal
					});
				}
			}, [])
		};
	});
});

const getEventLoggersLoadingStatus = ({ eventDetailsCMD }) => {
	return eventDetailsCMD.loggers?.loadingStatus;
};

const getEventLoggerSignalsLoadingStatus = ({ eventDetailsCMD }) => {
	return eventDetailsCMD.selectedLoggerSignals?.loadingStatus;
};

const getLoggerId = ({ eventDetailsCMD }) => eventDetailsCMD.loggerId?.data;

const getLoggersRawError = ({ eventDetailsCMD }) => {
	const loggerId = eventDetailsCMD.loggerId;
	const loggers = eventDetailsCMD.loggers;
	const selectedLoggerSignals = eventDetailsCMD.selectedLoggerSignals;

	if (loggerId?.loadingStatus === apiCallStatus.ERROR && loggerId?.error) {
		return { error: loggerId.error, errorCode: loggerId.error?.statusCode, loadingStatus: loggerId.loadingStatus };
	}
	if (loggers?.loadingStatus === apiCallStatus.SUCCESS && selectedLoggerSignals?.loadingStatus === apiCallStatus.ERROR && selectedLoggerSignals?.error) {
		return { error: selectedLoggerSignals.error, errorCode: selectedLoggerSignals.error?.statusCode, loadingStatus: selectedLoggerSignals.loadingStatus };
	}
	return { error: loggers?.error, errorCode: loggers?.error?.statusCode, loadingStatus: loggers?.loadingStatus };
};

const getLoggersErrorData = createErrorDataSelector(getLoggersRawError);

export const getModel = createSelector([
	getShowUtcDates,
	getEventLoggers,
	getEventLoggersLoadingStatus,
	getEventLoggerSignalsLoadingStatus,
	geSelectedLoggerSignalsData,
	getLoggerId,
	getLoggersErrorData
], (
	showUtcDates,
	loggers,
	loggersLoadingStatus,
	signalDataLoadingStatus,
	selectedLoggerSignals,
	loggerId,
	errorData
) => {
	return {
		showUtcDates,
		loggers,
		loggersLoadingStatus,
		signalDataLoadingStatus,
		selectedLoggerSignals,
		loggerId,
		errorData
	};
});
